<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center" v-if="checkPermission('AddDocument')">
          <router-link
            class="btn btn-primary"
            to="/documents/ajouter-document"
          >
            <i class="fa fa-plus-circle"></i>
            Ajouter document
          </router-link>
          
          
        </div>
        <div class="d-flex align-items-center">
         <form class="search-bg svg-color pt-3" @submit.prevent="rechercher">
            <input
              type="text"
              v-model="searchTerm"
              @keyup="rechercher"
              class="form-control shadow-none text-black"
              placeholder="Rechercher document"
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
         
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Réference
                </th>
                 <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Titre
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                Année Pub..
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
               Categorie
                </th>
                 <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
               Secteur
                </th>
                <!-- <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                Maison Edition
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                Date
                </th> -->
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0"
                >ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(document, index) in documents" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ (document.reference) ? document.reference : '-' }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{truncateText(document.titre, 10 )}}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ document.anneePublication }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ document.categorie?.nom }}
                </td>
                 <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ document.secteur?.nom }}
                </td>
                <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ document.maisonEdition?.nom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ format_date(document.createdAt) }}
                </td> -->
                 <td
                  class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
                >
                  <div class="dropdown">
                    <span
                      class="badge text-white bg-primary fs-15 dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('ViewPDF')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" 
                        @click="openPdfViewer(document)"
                      >
                        <i
                          class="flaticon-eyes lh-1 me-8 position-relative top-1" 
                        ></i>
                        Lire PDF
                      </a>
                    </li>
                    <li v-if="checkPermission('ViewDocument')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" 
                      >
                        <i
                          class="flaticon-eyes lh-1 me-8 position-relative top-1" 
                        ></i>
                        Details
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
        >
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref} from "vue";
  import Swal from "sweetalert2";
  import {Document } from "@/models/Document";
  import ApiService from "@/services/ApiService";
  import { format_date,suppression, error } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
  import { useRouter } from 'vue-router';
import TextTruncation from "../Utilities/TextTruncation/TextTruncation.vue";
  
  export default defineComponent({
    name: "ListeDocument",
    components: {
      PaginationComponent
    },
    setup(){
      
      onMounted(() => {
        getAllDocuments();
      });
  
      const documents = ref<Array<Document>>([]);   
      const document = ref<Document>();
  
      // BEGIN PAGINATE
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const router = useRouter();
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAllDocuments(page_, limit_);
        } catch (error) {
          //
        }
      };
  
       function rechercher(){
        getAllDocuments(page.value, limit.value, searchTerm.value );
      }
      
  
      // END PAGINATE
  
      function getAllDocuments(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/all/documents?page=${page}&limit=${limi}&mot=${searchTerm}&`)
          .then(({ data }) => {
            console.log('valeurs',data);
            documents.value = data.data.data;
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            return data.data;
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
        
      }
      function truncateText(text: string, maxLength: number): string {
        if (!text) return ''
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
      }
      function moddifier(EditDocument:Document) {
        document.value = EditDocument;
      }


      const openPdfViewer = (document: Document) => {
        // Rediriger vers une nouvelle page avec le lecteur PDF
        console.log('Document sélectionné:', document);
        
        // Construire l'URL complète du PDF
        let pdfUrl = `${process.env.VUE_APP_BASEURL}/uploads/2025080113391339130buLZ33wKT.pdf`; // URL par défaut
        
        if (document?.nomFichier) {
          pdfUrl = `${process.env.VUE_APP_BASEURL}/uploads/${document.nomFichier}`;
        }
        
        console.log('URL PDF utilisée:', pdfUrl);
        
        router.push({ 
          name: 'pdf-viewer',
          params: { id: document.id ?? 1 },
          query: { pdfUrl: pdfUrl }
        });
      };

      

      const deleteDocument = (id: number) => {
        ApiService.delete(`/documents/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
  
        for(let i = 0; i < documents.value.length; i++) {
          if (documents.value[i].id === id) {
            documents.value.splice(i, 1);
          }
        }
      };
  
      const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
      const checkPermission = (name) => {
        return privileges.value.includes(name);
      }
  
      return { documents,
        openPdfViewer,
        checkPermission,
       getAllDocuments,
       format_date,
       deleteDocument,
       moddifier ,
       suppression,
       page, 
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      truncateText
    };
    },
  });
  </script>
